import React from 'react'
import type { receiptSummary } from '../flow'
import { FieldHint, LabelGroupCard, QuantityLedger } from '../styles'

const number = (value: number) => value.toLocaleString('en-US')
export const StageLineSummary = ({ line }: { line: ReturnType<typeof receiptSummary>[number] }) => (
  <LabelGroupCard>
    <h2>{line.sku}</h2>
    <QuantityLedger>
      <div>
        <dt>Expected</dt>
        <dd>{number(line.expectedUnits)}</dd>
      </div>
      <div>
        <dt>Received</dt>
        <dd>{number(line.receivedUnits)}</dd>
      </div>
      <div className="total">
        <dt>
          {line.receivedUnits > line.expectedUnits
            ? 'Overage'
            : line.receivedUnits < line.expectedUnits
              ? 'Short'
              : 'Matched'}
        </dt>
        <dd>
          {line.expectedUnits === line.receivedUnits ? '✓' : number(Math.abs(line.expectedUnits - line.receivedUnits))}
        </dd>
      </div>
    </QuantityLedger>
    {line.additional !== 0 ? (
      <FieldHint>
        Additional {number(line.additional)} · Planned {number(line.target)} ·{' '}
        {line.receivedUnits > line.target ? 'Over plan' : 'Remaining'}{' '}
        {number(Math.abs(line.target - line.receivedUnits))}
      </FieldHint>
    ) : null}
  </LabelGroupCard>
)
